<template>
    <v-card 
      class="mx-auto my-8 pa-4"
      max-width="344"
      elevation="16"
    >
      <v-card-title style="text-align: center;">{{ $t('login') }}<br />{{ appName }}</v-card-title>
      <v-card-item>
        <v-form @submit.prevent="login">
          <v-text-field
            prepend-inner-icon="mdi-account"
            v-model="username"
            :label="$t('username')"
            variant="solo"
          ></v-text-field>
          <v-text-field 
            prepend-inner-icon="mdi-lock-outline"
            :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
            :type="visible ? 'text' : 'password'"
            v-model="password"
            :label="$t('password')"
            variant="solo"
            @click:append-inner="visible = !visible"
          ></v-text-field>
          <v-btn type="submit" color="#1F3A3B" block class="mt-2">{{ $t('login') }}</v-btn>
        </v-form>
      </v-card-item>
    </v-card>
</template>
  
<script setup>
  import { ref } from 'vue';
  import { useStore } from 'vuex';
  import { useRouter } from 'vue-router';
  import { useI18n } from 'vue-i18n';
  import { useTheme } from 'vuetify';

  // Use i18n for translations
  const { t } = useI18n();
  const appName = process.env.VUE_APP_NAME || 'Convatec';

  // Routed instance
  const router = useRouter();

  // Local reactive state
  const username = ref('');
  const password = ref('');
  const visible = ref(false);

  // Access Vuex store
  const store = useStore();

  // Settings theme mode
  const theme = useTheme();
  const savedTheme = localStorage.getItem('theme');
  if (savedTheme) {
    theme.global.name.value = savedTheme;
  }

  const login = async () => {
    try {
      const response = await store.dispatch('auth/login', { username: username.value, password: password.value });
      console.log('Login successful', response);
      router.push({ name: 'dashboard' });
    } catch (error) {
      password.value = '';
      console.error('Login failed', error);
    }
  };
</script>